module.exports = __webpack_public_path__ + "media/images/greennote 8-0f3d32e36fc1bff3a33602766cd24afe.svg";